import produce from 'immer';
import {
    SET_PRODUCT_COLOUR,
    SET_PRODUCT_SIZE,
    SET_PRODUCT_LENGTH,
    SET_FOUNDATION_COLOUR_MATCH,
    RESET_PRODUCT_SIZE,
    RESET_PRODUCT_LENGTH,
    TOGGLE_SIZE_MODAL,
    SET_SELECTION,
    SET_PRODUCT_DATA_FORMAT,
    SET_RELATED_ITEMS_FETCHED,
    SET_TOASTS,
    SET_NAVIGATION_ID
} from '../actions/constants';

const initialState = {
    isBeautyCategory: false,
    isSizeModalVisible: false,
    eansData: {},
    eansWithB2C: {},
    current: {
        productID: null,
        variantID: null,
        ean_id: null,
        colourDetail: null,
        sizeDetail: null
    },
    selection: null,
    newProductDataFormat: null,
    isRelatedItemsFetched: false,
    toasts: [],
    navigationId: null
};

const ProductReducer = produce((state, action) => {
    const { type, payload } = action;

    switch (type) {
        case SET_PRODUCT_LENGTH:

        // eslint-disable-next-line no-fallthrough
        case SET_PRODUCT_SIZE: {
            state.current = { ...state.current, ...payload };
            break;
        }

        case SET_PRODUCT_COLOUR: {
            state.current = { ...state.current, ...payload };
            state.selection = null;
            break;
        }

        case SET_FOUNDATION_COLOUR_MATCH: {
            state.colourMatch = payload;
            break;
        }

        case RESET_PRODUCT_SIZE: {
            state.current.sizeDetail = null;
            break;
        }

        case RESET_PRODUCT_LENGTH: {
            // Force delete
            if (payload) {
                delete state.current.lengthDetail;
            } else {
                state.current.lengthDetail = null;
            }

            break;
        }

        case TOGGLE_SIZE_MODAL: {
            state.isSizeModalVisible = payload;
            break;
        }

        case SET_PRODUCT_DATA_FORMAT: {
            state.newProductDataFormat = { ...state.newProductDataFormat, ...payload };
            break;
        }

        case SET_SELECTION: {
            state.selection = payload;
            break;
        }

        case SET_RELATED_ITEMS_FETCHED: {
            state.isRelatedItemsFetched = payload;
            break;
        }

        case SET_TOASTS: {
            state.toasts = payload;
            break;
        }

        case SET_NAVIGATION_ID: {
            state.navigationId = payload;
            break;
        }
        // skip default
    }
}, initialState);

export default ProductReducer;
